// extracted by mini-css-extract-plugin
module.exports = {"large":"MenuItems-module--large--2uWvf","small":"MenuItems-module--small--2dFHM"};